// @flow
import { useState, useCallback } from 'react';
import assoc from 'ramda/es/assoc';


type FormErrors = {
  schoolId: string,
  recipientIds: string,
  subject: string,
  content: string,
}

const defaultErrorsState: FormErrors = {
  schoolId: '',
  recipientIds: '',
  subject: '',
  content: '',
};


export default function useStatementEditFormErrors() {
  const [errors, setErrors] = useState(defaultErrorsState);

  const handleSetError = useCallback((key: string, value: string) => {
    setErrors(assoc(key, value));
  }, []);

  const handleResetErrors = useCallback(() => {
    setErrors(defaultErrorsState);
  }, []);

  return [errors, handleSetError, handleResetErrors];
}
